function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "portfolio"
}, /*#__PURE__*/React.createElement("g", {
  id: "ring"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M1045 49.8594H1045C1027.96 49.8594 1011.31 54.9115 997.143 64.3767C982.977 73.842 971.936 87.2953 965.416 103.035C958.897 118.776 957.191 136.096 960.515 152.805C963.838 169.515 972.042 184.864 984.089 196.911C996.136 208.958 1011.49 217.162 1028.19 220.486C1044.9 223.809 1062.22 222.103 1077.96 215.584C1093.7 209.064 1107.16 198.023 1116.62 183.857C1126.09 169.691 1131.14 153.037 1131.14 136V135.999C1131.11 113.162 1122.03 91.2666 1105.88 75.1178C1089.73 58.969 1067.84 49.8853 1045 49.8594ZM1045 222.5C1027.89 222.5 1011.17 217.427 996.943 207.922C982.718 198.417 971.631 184.908 965.084 169.102C958.537 153.296 956.824 135.904 960.162 119.125C963.5 102.345 971.738 86.9325 983.835 74.8353C995.933 62.7381 1011.35 54.4997 1028.12 51.1621C1044.9 47.8245 1062.3 49.5375 1078.1 56.0845C1093.91 62.6314 1107.42 73.7184 1116.92 87.9432C1126.43 102.168 1131.5 118.892 1131.5 135.999C1131.47 158.933 1122.35 180.92 1106.14 197.136C1089.92 213.352 1067.93 222.474 1045 222.5Z",
  fill: "#3F3D56",
  stroke: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_2",
  d: "M1045.12 179.935C1069.25 179.935 1088.81 160.377 1088.81 136.25C1088.81 112.123 1069.25 92.5641 1045.12 92.5641C1021 92.5641 1001.44 112.123 1001.44 136.25C1001.44 160.377 1021 179.935 1045.12 179.935Z",
  fill: "#F2F2F2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_3",
  d: "M1105.08 92.4626C1114.81 92.4626 1122.7 84.576 1122.7 74.8475C1122.7 65.1189 1114.81 57.2323 1105.08 57.2323C1095.35 57.2323 1087.47 65.1189 1087.47 74.8475C1087.47 84.576 1095.35 92.4626 1105.08 92.4626Z",
  fill: "#00BFA6"
})), /*#__PURE__*/React.createElement("g", {
  id: "Vector_4",
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1045.42 128.517H64.2437V621.441H1045.42V128.517Z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  d: "M64.7437 620.941V129.017H1044.92V620.941H64.7437Z",
  stroke: "black"
})), /*#__PURE__*/React.createElement("path", {
  id: "Vector_5",
  d: "M93.4454 158.886C99.8964 158.886 105.126 153.657 105.126 147.206C105.126 140.755 99.8964 135.525 93.4454 135.525C86.9943 135.525 81.7647 140.755 81.7647 147.206C81.7647 153.657 86.9943 158.886 93.4454 158.886Z",
  fill: "#00BFA6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_6",
  d: "M129.655 158.886C136.107 158.886 141.336 153.657 141.336 147.206C141.336 140.755 136.107 135.525 129.655 135.525C123.204 135.525 117.975 140.755 117.975 147.206C117.975 153.657 123.204 158.886 129.655 158.886Z",
  fill: "#00BFA6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_7",
  d: "M165.866 158.886C172.317 158.886 177.546 153.657 177.546 147.206C177.546 140.755 172.317 135.525 165.866 135.525C159.414 135.525 154.185 140.755 154.185 147.206C154.185 153.657 159.414 158.886 165.866 158.886Z",
  fill: "#00BFA6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_8",
  d: "M200.908 311.903H177.546V335.264H200.908V311.903Z",
  fill: "#00BFA6"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_9",
  d: "M912.26 515.147H888.899V538.508H912.26V515.147Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_10",
  d: "M829.893 352.711L811.732 367.405L826.426 385.566L844.587 370.872L829.893 352.711Z",
  fill: "#00BFA6"
}), /*#__PURE__*/React.createElement("g", {
  id: "picture"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_11",
  opacity: 0.1,
  d: "M770 256H340V523H770V256Z",
  fill: "url(#paint0_linear)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_12",
  d: "M644.715 523.318H616.305L616.115 520.988L614.045 495.018V495.008L611.895 468.008L625.005 412.318L636.145 423.458V476.528C636.145 476.528 642.695 486.358 641.385 488.978C640.075 491.598 638.765 491.598 640.075 493.558C641.385 495.528 642.695 496.838 641.385 498.148C640.747 499 640.403 500.035 640.403 501.098C640.403 502.162 640.747 503.197 641.385 504.048C642.695 505.358 645.315 507.318 643.345 509.288C641.385 511.248 638.765 509.938 641.385 517.148C641.865 518.481 642.468 519.766 643.185 520.988C643.652 521.792 644.163 522.57 644.715 523.318Z",
  fill: "#D0CDE1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_13",
  d: "M557.189 343.847L553.258 383.159L593.225 389.056L596.173 366.452L599.122 343.847H557.189Z",
  fill: "#FFB9B9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_14",
  opacity: 0.1,
  d: "M557.189 343.847L553.258 383.159L593.225 389.056L596.173 366.452L599.122 343.847H557.189Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_15",
  d: "M579.138 356.624C596.507 356.624 610.588 342.543 610.588 325.174C610.588 307.805 596.507 293.724 579.138 293.724C561.769 293.724 547.688 307.805 547.688 325.174C547.688 342.543 561.769 356.624 579.138 356.624Z",
  fill: "#FFB9B9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_16",
  d: "M499.665 523.318C499.555 523.088 499.435 522.848 499.315 522.588C499.085 522.098 498.835 521.568 498.565 520.988C496.825 517.108 494.695 511.588 495.925 509.938C497.895 507.318 498.545 504.698 497.235 503.388C495.925 502.078 491.995 504.698 495.925 501.418C499.855 498.148 501.165 500.108 499.855 496.178C498.545 492.248 495.925 494.218 498.545 492.248C501.165 490.288 503.135 490.938 501.825 488.978C500.515 487.008 497.895 487.008 500.515 485.698C503.135 484.388 505.105 485.698 504.445 482.418C503.785 479.148 503.135 480.458 504.445 479.148C504.785 478.808 505.975 475.508 507.565 470.798C512.015 457.488 519.515 432.938 519.515 431.968C519.515 430.658 509.035 389.388 509.035 389.388L504.445 386.758C504.445 386.758 484.135 400.518 477.585 431.318C471.025 462.108 466.445 469.978 466.445 469.978C466.445 469.978 459.895 471.288 464.475 475.868C469.065 480.458 469.065 479.798 465.135 482.418C461.205 485.038 458.585 479.798 461.205 485.038C463.825 490.288 467.095 488.978 464.475 492.248C461.855 495.528 457.275 495.528 459.895 498.148C462.515 500.768 457.275 506.668 460.545 509.288C463.825 511.908 465.135 512.558 465.135 517.148C465.136 518.434 465.24 519.718 465.445 520.988C465.558 521.774 465.718 522.552 465.925 523.318C466.075 523.928 466.225 524.388 466.325 524.678L499.665 523.318Z",
  fill: "#D0CDE1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_17",
  d: "M499.665 523.318H502.335L502.475 522.388L499.315 522.588L487.825 523.318L466.325 524.678L499.665 523.318Z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_18",
  d: "M513.615 495.528L507.725 475.218L507.565 470.798L504.445 386.758L543.105 373.008L549.655 367.758C549.655 367.758 550.965 352.688 552.935 351.378C553.645 350.908 554.785 351.458 556.295 352.738C558.945 354.988 562.745 359.478 567.345 364.488C574.555 372.348 589.625 371.038 594.205 368.418C594.794 368.075 595.406 367.771 596.035 367.508C599.325 366.148 600.755 367.108 600.755 367.108C604.035 369.728 596.175 378.248 596.175 378.248C596.175 378.248 598.795 384.138 615.825 390.038C632.865 395.938 636.145 423.458 636.145 423.458C636.145 423.458 615.825 478.488 616.485 482.418C617.045 485.788 614.725 493.008 614.045 495.008V495.018C613.935 495.338 613.865 495.528 613.865 495.528L615.355 520.988L615.495 523.318H516.385C516.09 522.508 515.719 521.728 515.275 520.988C515.165 520.808 515.045 520.618 514.925 520.428C509.035 511.248 513.615 495.528 513.615 495.528Z",
  fill: "#D0CDE1"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_19",
  d: "M547.47 329.203C547.47 329.203 544.204 324.304 545.461 319.028C546.211 316.033 546.508 312.942 546.34 309.859C546.34 309.859 548.978 301.317 551.615 296.544C554.253 291.771 552.997 289.761 561.287 288.254C569.578 286.746 566.186 275.944 588.043 287.625C588.78 288.655 589.806 289.443 590.991 289.89C592.176 290.337 593.466 290.423 594.7 290.138C599.222 289.258 600.855 295.539 600.855 295.539C600.855 295.539 603.87 293.78 605 296.293C606.131 298.805 614.191 294.785 614.191 311.742C614.191 328.7 605.018 343.847 605.018 343.847C605.018 343.847 605.691 315.323 590.743 312.434C575.796 309.545 559.717 301.129 555.823 311.931C553.722 317.994 550.918 323.791 547.47 329.203Z",
  fill: "#2F2E41"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_20",
  d: "M605.346 335.985C606.974 335.985 608.294 334.225 608.294 332.054C608.294 329.882 606.974 328.122 605.346 328.122C603.718 328.122 602.398 329.882 602.398 332.054C602.398 334.225 603.718 335.985 605.346 335.985Z",
  fill: "#FFB9B9"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_21",
  d: "M339.905 252.328V523.318H769.755V252.328H339.905ZM767.425 520.988H342.245V254.668H767.425V520.988Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  id: "ruler"
}, /*#__PURE__*/React.createElement("g", {
  id: "rulerX"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_22",
  d: "M758.546 647.336H25L27.336 645H758.546V647.336Z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_23",
  d: "M772.58 661.025C769.577 661.025 766.641 660.135 764.144 658.466C761.646 656.798 759.7 654.426 758.551 651.651C757.402 648.877 757.101 645.823 757.687 642.878C758.273 639.932 759.719 637.227 761.843 635.103C763.966 632.979 766.672 631.533 769.617 630.947C772.563 630.361 775.616 630.662 778.391 631.811C781.166 632.961 783.537 634.907 785.206 637.404C786.874 639.901 787.765 642.837 787.765 645.84C787.76 649.866 786.159 653.726 783.312 656.572C780.465 659.419 776.606 661.02 772.58 661.025V661.025ZM772.58 632.992C770.039 632.992 767.554 633.745 765.441 635.157C763.329 636.569 761.682 638.575 760.709 640.923C759.737 643.271 759.482 645.855 759.978 648.347C760.474 650.839 761.697 653.129 763.494 654.926C765.291 656.723 767.581 657.946 770.073 658.442C772.566 658.938 775.149 658.683 777.497 657.711C779.845 656.738 781.851 655.092 783.263 652.979C784.675 650.866 785.429 648.382 785.429 645.84C785.425 642.434 784.07 639.168 781.661 636.759C779.252 634.35 775.986 632.995 772.58 632.992V632.992Z",
  fill: "#3F3D56"
})), /*#__PURE__*/React.createElement("g", {
  id: "rulerY"
}, /*#__PURE__*/React.createElement("path", {
  id: "Vector_24",
  d: "M25.017 647.009V252.202H27.353V644.673L25.017 647.009Z",
  fill: "#3F3D56"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector_25",
  d: "M26.1849 253.37C23.1816 253.37 20.2458 252.479 17.7486 250.811C15.2515 249.142 13.3052 246.771 12.1559 243.996C11.0066 241.221 10.7059 238.168 11.2918 235.222C11.8777 232.277 13.3239 229.571 15.4476 227.448C17.5712 225.324 20.2769 223.878 23.2225 223.292C26.168 222.706 29.2212 223.007 31.9959 224.156C34.7706 225.305 37.1421 227.251 38.8107 229.749C40.4792 232.246 41.3698 235.182 41.3698 238.185C41.3653 242.211 39.764 246.071 36.9173 248.917C34.0705 251.764 30.2108 253.365 26.1849 253.37V253.37ZM26.1849 225.336C23.6436 225.336 21.1595 226.09 19.0465 227.502C16.9335 228.913 15.2867 230.92 14.3142 233.268C13.3417 235.616 13.0873 238.199 13.583 240.692C14.0788 243.184 15.3025 245.473 17.0995 247.27C18.8964 249.067 21.1858 250.291 23.6782 250.787C26.1706 251.283 28.7541 251.028 31.1019 250.056C33.4497 249.083 35.4564 247.436 36.8682 245.323C38.2801 243.21 39.0336 240.726 39.0336 238.185C39.0298 234.778 37.6748 231.513 35.2661 229.104C32.8573 226.695 29.5914 225.34 26.1849 225.336V225.336Z",
  fill: "#3F3D56"
}))));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 60.2437,
  y: 128.517,
  width: 989.176,
  height: 500.924,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 770,
  y1: 256,
  x2: 770,
  y2: 523,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3E3C55"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.286458,
  stopColor: "#00BFA6"
})));

function SvgMiniBrowser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1169,
    height: 685,
    viewBox: "0 0 1169 685",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniBrowser);
export default __webpack_public_path__ + "static/media/mini-browser.6b1354a5.svg";
export { ForwardRef as ReactComponent };